import VOptionSet from "../vOptionSet";

export default abstract class CustomVOptionSet<T = any> extends VOptionSet<T> {
  abstract search(q: string): Promise<{}>;
}

